<!--
 * @FileDescription: 销售订单——已完成
 * @Author: ryb（作者）
 * @Date: 2020-07-16（时间）
 -->
<template>
  <div class="sales-order-complete">
    <div class="sales-order-information" id="page-top">
      <a-row class="ant-row-one">
        <a-col>
          <span class="a-col-title">单据单号：</span>
          <span class="a-col-value">{{ orderDetails.code }}</span>
        </a-col>
        <a-col style="margin-right: 0">
          <span class="a-col-title">单据日期：</span>
          <span class="a-col-value">{{ orderDetails.voucherDate }}</span>
        </a-col>
      </a-row>
      <a-row class="ant-row-two">
        <a-col>
          <span class="a-col-title">收货人：</span>
          <span class="a-col-value">{{ orderDetails.receiveName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">经办人：</span>
          <span class="a-col-value">{{ orderDetails.transactorName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">发货门店：</span>
          <span class="a-col-value">{{ orderDetails.outStoreName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">备注：</span>
          <span class="a-col-value">{{ orderDetails.remark }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title" style="color:#F76F14">用户备注：</span>
          <span class="a-col-value">{{ orderDetails.memberRemark }}</span>
        </a-col>
      </a-row>
    </div>
    <div class="sales-order-content" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" :scroll="{ y: tableHeight }"
        bordered>
        <!-- 序号 -->
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{  index+1 }}</span>
        </template>
        <!-- 商品名称 -->
        <template slot="productName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px" v-if="record.giftFlag==1">
              <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品编号 -->
        <template slot="productCode" slot-scope="text">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 状态 -->
        <template slot="returnState" slot-scope="text">
          <div class="order-staus">
            <div class="order-staus-left">
              <span class="status-round" :style="{backgroundColor:text==1?'#F76F14' :'#199A2C'}"></span>
            </div>
            <div class="order-staus-right">
              <span>
                {{ text==1?'待退货' :text==2?'待退款' :text==3?'已退款'  :"--" }}
              </span>
            </div>
          </div>
        </template>
      </a-table>
    </div>
    <div class="sales-order-footer-two" id="page-button">
      <div class="sales-order-footer-left" v-if="dataDetails.distributionMode==1">
        <a-row>
          <a-col>
            <span class="a-col-title">配送方式：</span>
            <span class="a-col-value">到店自提</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <span class="a-col-title">到店时间：</span>
            <span class="a-col-value">{{ dataDetails.arrivalStoreTime }}</span>
          </a-col>
        </a-row>
      </div>
      <div class="sales-order-footer-left" style="width: 100%" v-if="dataDetails.distributionMode==2">
        <a-row>
          <a-col>
            <span class="a-col-title">配送方式：</span>
            <span class="a-col-value">送货上门</span>
          </a-col>
          <a-col>
            <span class="a-col-title">运费：</span>
            <span
              class="a-col-value">{{ dataDetails.includeFreightFlag==0?"到付" :dataDetails.includeFreightFlag==0?"包邮" :"--" }}</span>
          </a-col>
          <a-col>
            <span class="a-col-title">物流公司：</span>
            <span class="a-col-value">{{ dataDetails.logisticsCompanyName }}</span>
            <span>{{ dataDetails.trackingNumber }}</span>
            <span class="btn-copy" v-clipboard="dataDetails.trackingNumber" @click="btnCopy">复制</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <span class="a-col-title">配送信息：</span>
            <span class="a-col-value">{{ orderDetails.receiveName }} {{ orderDetails.receiveMobile }}
              {{ orderDetails.receiveAddress }}</span>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- 底部按钮组件 -->
    <public-footer ref="footer" :buttonList="buttonList" @onClickButton="onClickButton"></public-footer>
  </div>
</template>
<script>
import { tableWidth } from "@/mixins/tableWidth";
import publicFooter from "@/components/module/publicFooter.vue";
export default {
  mixins: [tableWidth],
  components: {
    publicFooter,
  },
  props: {
    orderDetails: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      columns: [
        {
          title: "序号",
          align: "center",
          width: 80,
          dataIndex: "serialNum",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          defaultWidth: 180,
          title: "商品名称",
          dataIndex: "productName",
          scopedSlots: { customRender: "productName" },
        },
        {
          defaultWidth: 180,
          title: "商品编号",
          dataIndex: "productCode",
        },
        {
          title: "规格",
          dataIndex: "productSpecification",
        },
        {
          title: "型号",
          dataIndex: "productModel",
        },
        {
          title: "单位",
          dataIndex: "productUnitName",
          scopedSlots: { customRender: "productUnitName" },
        },
        {
          title: "数量",
          align: "right",
          dataIndex: "productTotalCount",
        },
        {
          title: "售后数量",
          align: "right",
          dataIndex: "returnTotalCount",
        },
        {
          title: "门店成本价",
          align: "right",
          dataIndex: "price",
        },
        {
          title: "金额",
          align: "right",
          dataIndex: "amountCount",
        },
        {
          title: "状态",
          dataIndex: "returnState",
          scopedSlots: { customRender: "returnState" },
        },
      ],
      buttonList: [
        {
          id: 2,
          text: "取消退出",
        },
      ],
      dataSource: [],
      contentHeight: 0,
      tableHeight: 0,
      formData: {},
      dataDetails: {},
      urlList: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 表格高度计算
      let _that = this;
      setTimeout(function () {
        let tdHeight = document.getElementsByTagName("tr")[0].offsetHeight;
        let header = document.getElementById("header").offsetHeight;
        let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
        let pageHeight = document.getElementById("content").offsetHeight;
        let makeTop = document.getElementById("page-top").offsetHeight;
        let makeButton = document.getElementById("page-button").offsetHeight;
        _that.contentHeight =
          pageHeight -
          makeTop -
          makeButton -
          header -
          breadcrumb -
          tdHeight * 1.2;
        _that.tableHeight = _that.contentHeight - tdHeight * 2;
      }, 50);
    },
    // 取消退出
    onClickButton(item) {
      if (item.id == 2) {
        this.$router.go(-1);
        this.$store.state.closePath = this.$route.fullPath;
      }
    },
    // 复制单号
    btnCopy() {
      this.$message.success("复制单号成功");
    },
  },
  watch: {
    orderDetails() {
      this.dataDetails = this.orderDetails;
      this.dataSource = this.orderDetails.salesOrderItemMallVOList;
    },
  },
};
</script>

<style lang="scss">
.sales-order-complete {
  @import "../style/salesOrderDetails.scss";
  .order-staus {
    height: 100%;
    display: flex;
    align-items: center;
    .status-round {
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      margin-right: 6px;
    }
    .refuse-reason {
      width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .order-staus-left {
      display: flex;
      align-items: center;
    }
  }
}
</style>
